const storePersistKey = `_zg_cli_${process.env.NODE_ENV}_state`.toUpperCase();
export {
  storePersistKey
}



// WEBPACK FOOTER //
// ./src/plugins/tools/Constant.js